import { doItemAction } from '#utils/PRIVATE_legendUtils/testAdapterUtil';
import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';

export class LegendAdapter extends TestAdapter {
  async doItemAction(id: number | string): Promise<void> {
    await doItemAction(id, await this.getElement());
  }
}
